<template>
	<div class="index_bg">

		<div class="brand">
			<div class="brand_logo">
				<img v-if="isWebsiteSetupPO" :src="brand.brandLogoPic"/>
				<img v-else src="../assets/logo.png"/>
			</div>
			<div class="brand_name">{{brand.companySortName}}</div>
		</div>
			
		<div class="index_main">
			<div class="main_cont">
				<router-link class="user" to="/set">
					<div class="ui-flex">
						<div class="user_avata">
							<img :src="userInfo.wxHeaderImage"/>
						</div>
						<div class="user_info ui-flex-1">
							<div class="user_name">{{userInfo.customerName}}</div>
							<div class="user_desc">{{userInfo.customerPhone}}</div>
						</div>
						<div style="line-height: 52px;">
							<van-icon name="arrow" color="#aaa"/>
						</div>
					</div>
				</router-link>
				<div class="main_fn ui-flex">
					<div class="main_fn_item ui-flex-1">
						<router-link class="main_fn_bg" style="background: #fff6f4; background-image: linear-gradient(80deg, #f5e5e2, #fff6f4);" to="/invoice/gth">
							<div class="main_fn_icon">
								<van-icon name="add" size="24" color="#dc5926"/>
							</div>
							<div class="main_fn_name">申请开票</div>
						</router-link>
					</div>
					<div class="main_fn_item ui-flex-1">
						<router-link class="main_fn_bg" style="background: #f2f2ff;background-image: linear-gradient(80deg, #e3e2f9, #f2f2ff);" to="/invoice/list">
							<div class="main_fn_icon">
								<van-icon name="coupon" size="24" color="#205cd7"/>
							</div>
							<div class="main_fn_name">我的开票</div>
						</router-link>
					</div>
				</div>
			</div>
			
			<div class="nav_box">
				<router-link to="/home/address">
					<div class="nav-item ui-flex">
						<div class="nav-icon">
							<van-icon name="location-o" size="18"/>
						</div>
						<div class="nav-item-val cell-access-icon ui-flex-1 retina-1px-border-bottom">地址簿</div>
					</div>
				</router-link>
				<router-link to="/home/title">
					<div class="nav-item ui-flex">
						<div class="nav-icon">
							<van-icon name="hotel-o" size="18"/>
						</div>
						<div class="nav-item-val cell-access-icon ui-flex-1 retina-1px-border-bottom">开票抬头</div>
					</div>
				</router-link>
				<router-link to="/home/project">
					<div class="nav-item ui-flex">
						<div class="nav-icon">
							<van-icon name="orders-o" size="18"/>
						</div>
						<div class="nav-item-val cell-access-icon ui-flex-1 retina-1px-border-bottom">工程管理</div>
					</div>
				</router-link>
				<a :href="'tel:'+brand.companyPhone">
					<div class="nav-item ui-flex">
						<div class="nav-icon">
							<van-icon name="phone-circle-o" size="18"/>
						</div>
						<div class="nav-item-val cell-access-icon ui-flex-1">联系客服</div>
					</div>
				</a>
			</div>
			
		</div>
		

		<div class="copyright">
			<div>{{brand.companyName }}</div>
			<div>Copyright © 2022 {{brand.companySortName }} All Rights Reserved</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loading : false,
				userInfo : false,
				brand : {},
				isWebsiteSetupPO : false
			};
		},
		mounted() {
			this.getUserInfo();
			this.getBrand();
		},
		methods: {
			getBrand(){
				this.$get('/gtb/findWetSet.html').then(res=>{
					if( res.success ){
						this.isWebsiteSetupPO = res.isWebsiteSetupPO > 0;
						if( res.isWebsiteSetupPO > 0 ){
							this.brand = res.websiteSetupPO
						}else{
							this.brand = {
								brandLogoPic : '',
								customerName : '个体户小管家',
								companyName : '',
								companyPhone : '4006888002'
							}
						};
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch(error=>{
				});
			},
			getUserInfo() {
				this.$toast.loading({
					message: '请求中...',
					forbidClick: true,
					duration : 0
				});
				this.$get("/gtb/home/findCustomer.html").then(res => {
					this.$toast.clear();
					if( res.success ){
						this.userInfo = res.customerInfoPO
					}
				}).catch(error=>{
					this.$toast.clear();
				});
			}
		},
	};
</script>

<style>
	.index_bg{background: url(../assets/index_bg.png) no-repeat; background-size: 100%; }
	.index_main{ padding: 0 16px;}
	.main_cont{padding: 20px; border-radius: 12px;  background: #fff; margin-bottom: 15px;}
	.user{ margin-bottom: 20px; display: block;}
	.user_avata{ margin-right: 12px;}
	.user_avata img{ width: 46px; height: 46px; border-radius: 50%; display: block; }
	.user_info{ padding-top: 2px;}
	.user_name{ font-size: 18px; line-height: 22px; margin-bottom: 2px; }
	.user_desc{ font-size: 14px; color: #999;}
	
	.brand{ padding: 20px; margin-bottom: 5px; text-align: center;}
	.brand_logo img{ width: 52px; height: 52px; border-radius: 50%; box-shadow: 0 2px 10px rgba(0,0,0,0.1);}
	.brand_name{ font-size: 16px; font-weight: bold; padding-top: 6px; color: #404549; }
	
	.main_fn{ margin: 0 -5px; }
	.main_fn_item{ padding: 0 5px;}
	.main_fn_bg{ color: #333; padding-top: 15px; height: 80px; text-align: center;border-radius: 9px; display: block;}
	.main_fn_name{ padding-top: 6px; font-weight: bold;}
	
	.nav_box{ background: #fff; padding: 0 18px; margin-bottom: 10px; border-radius: 12px;}
	.nav-item{ position: relative; }
	.nav-item-val{ position: relative;padding: 16px 0;}
	.nav-icon{ width: 36px;display:flex;align-items: center;line-height: 52px; }
	.nav-right{ padding-right: 18px;}
	
	.copyright{ text-align: center; padding: 20px 16px; color: #999; font-size: 12px; line-height: 18px;}
</style>
